import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy, ChangeDetectorRef, ViewChild, ElementRef, HostListener, OnChanges } from '@angular/core';
import {IrbEditorsEvents, IEvent, IrbAppEvents} from "@irb-common/events";
import { IRebalanceTypeItem } from '@irb/irb-create-rebalance/irb-create-rebalance.service';
import { FormControl } from '@angular/forms';
import { IrbRebalanceEditor } from '@irb/irb-editors/irb-editors.rebalance.base';
import { IAnalysisPackage, ISaveRebalanceResponse, ISchedulerDTO, ISaveRebalanceAsync } from '../rebalance/irb-rebalance.model';
import {Observable, of } from 'rxjs';
import { IAlertDialogData } from '@irb/app.model';
import { RebalanceService } from '../rebalance/rebalance.service';
import { ISmartFilterDto } from '../irb-editors.model';
import { RebalanceIncludedPortfolioComponent } from '../rebalance/rebalance-included-portfolio/rebalance-included-portfolio.component';
import {AnalyticsService} from "@irb-common/analytics/analytics.service";

@Component({ standalone: false,
  selector: 'irb-editor-manual-adjustment-rebalance',
  templateUrl: './manual-adjustment-rebalance.component.html',
  styleUrls: ['./manual-adjustment-rebalance.component.scss', "../../irb-common/styles/dialog.scss", "../editor-sidebar/editor-sidebar.component.scss"],
  changeDetection: ChangeDetectionStrategy.Default,
  encapsulation: ViewEncapsulation.None
})
export class EditorManualAdjustmentRebalanceComponent extends IrbRebalanceEditor implements OnInit {

    @ViewChild("body") body: ElementRef;
    @ViewChild("includedportfolio") includedportfolio: RebalanceIncludedPortfolioComponent;

    params: any;
    createRebalanceDate: any;
    rebalanceTypeLists: IRebalanceTypeItem[];
    selectedRebalanceType = new FormControl('');
    headerRebalanceType: any;
    defaultExpandedPanels: Array<string>;
    RebalanceResultId: any;
    isSchedulerRemove: boolean = false;
    summarySource:string;
    rebalanceTitle: string;
    saveLabel: string = "Process";
    isReadOnly: boolean = false;
    analysisName: string = "Manual Adj - ";
    analysisType: string = "Manual adjustment";
    isUnitTest: boolean = false;

  constructor(private cdr: ChangeDetectorRef,
    private readonly rebalanceService: RebalanceService,
    public ats: AnalyticsService
    ) {
    super();
        this.identifier = "analysisId";
  }

  ngOnInit() {
     this.createRebalanceDate = this.datePipe.transform(this.createRebalanceDate, 'yyyy-MM-dd');
   }


  /*smartFilterChange(smartFilterDto:any)
  {
    this.data.smartFilterDto=smartFilterDto;
    this.onInputChange();
  }*/
  getDefaultExpandedPanels() {
    let source = this.rebalanceService.getRebalanceSource();
    if(!this.isSchedulerRemove) {
      this.defaultExpandedPanels = ["fullRebalance_included_portfilio","fullRebalance_scheduler"];
      // QC 168261
      // if(source!==undefined && source !== null && source !=='' && source.length > 0) {
      //   this.defaultExpandedPanels = ["fullRebalance_scheduler"];
      // }
    } else {
      this.defaultExpandedPanels = [];
    }
    return this.defaultExpandedPanels;
  }
  get(event: IEvent) {
    super.get(event);
    let eventData: IAnalysisPackage;
    let todayDate = this.datePipe.transform(new Date(), "MM/dd/yyyy");
    if (event.data) {
      this.rebalanceService.setRebalanceSource(event.data.source || null);
    }
    if (event.data !== null && event.data !== undefined && event.data.analysisId !== null && event.data.analysisId !== undefined) {
      eventData = event.data;
      this.rebalanceTitle = "View Manual Adjustment"
      this.summarySource = event.data.source;
      this.isSchedulerRemove = true;
      this.rebalanceService.getHistoryDetail(event.data.analysisId).subscribe((data: any) => {
        eventData = data.responseData;
        eventData.schedulerFrequency = "None";
        this.load(eventData);
      });
    } else {
      
      this.ignoreUnsavedChanges = true;
      this.rebalanceTitle = "Create Manual Adjustment";
      this.isReadOnly = false;
      this.saveLabel = "Process";
      eventData = {
        analysisType: this.analysisType,
        isNew: true,
        isUIdeleted: false,
        schedulerFrequency: "None",
        tradeExpln: "",
        isSysSuggestion: true,
        isUIAllPort: false,
        analysisName: this.analysisName + todayDate,
        smartFilterDto: (event.data && event.data.smartFilterDto) ? event.data.smartFilterDto: {
          analysisType: this.analysisType,
          isCategoryAll: false,
          isCategoryBlank: false,
          isModelAll: false,
          isModelBlank: false,
          modelUpdated: false,
          sfCategoryDtoList: null,
          sfModelDtoList: null,
          smartFilterDays: null,
          analysisPortDtoList: []
        } as ISmartFilterDto,
        scheduler: {
          isActive: false,
          scheduleType: "Adhoc"
        } as unknown as ISchedulerDTO
      } as IAnalysisPackage;

      if (event.data && event.data.modelId) {
        eventData.modelId = event.data.modelId;
        eventData.modelName = event.data.modelName;
      }
      
      this.isSchedulerRemove = false;
      this.applyRebalanceData(event, eventData, todayDate);
      let sessionOverridesDefault = false;
      this.defaultExpandedPanels = this.getDefaultExpandedPanels();
      this.ies.loadExpansionState(this.defaultExpandedPanels.length, "editor-manual-adjustment-rebalance", this.defaultExpandedPanels, sessionOverridesDefault);
      this.cdr.detectChanges();
      setTimeout(() => this.onResize());
    }
    if (this.summarySource !== null && this.summarySource !== undefined && this.summarySource === "resultSummary") {
      this.isReadOnly = true;
    }
    if (event.data.source !== null && event.data.source !== undefined && event.data.source === "portfolioDialog") {
      this.isModified = true;
      this.as.fireEvent(IrbEditorsEvents.IS_MODIFIED);
    }
    if (event.data.source !== null && event.data.source !== undefined && event.data.source === "rebalancePortfolioDialog") {
      if (this.data.smartFilterDto.analysisPortDtoList !== null && this.data.smartFilterDto.analysisPortDtoList !== undefined) {
        this.isReadOnly = false;
        this.isModified = true;
        this.originalData.summarySource = "rebalancePortfolioDialog";
        this.data.tradeExpln = undefined;
        this.cdr.detectChanges();
      }
    }
  }

  load(data: IAnalysisPackage) {
    super.load(data);
    let sessionOverridesDefault = false;
    // this.defaultExpandedPanels = ["fullRebalance_included_portfilio", "fullRebalance_scheduler"];
    this.defaultExpandedPanels = this.getDefaultExpandedPanels();
    this.ies.loadExpansionState(this.defaultExpandedPanels.length, "editor-manual-adjustment-rebalance", this.defaultExpandedPanels, sessionOverridesDefault);
    this.cdr.detectChanges();
    setTimeout(() => this.onResize());
  }
  
  saveRebalance() {
    const includePortfolioList = this.includedportfolio.getRowData();
    this.data.smartFilterDto.analysisPortDtoList = includePortfolioList;
    this.data.smartFilterDto.analysisPortDtoListCount = includePortfolioList.length;
    this.validateInput().subscribe(errors => {
      if (errors.length > 0) {
        let errMsg: string = errors.join("\n");
        this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
            dTitle: "Alert",
            msg: errMsg,
            dProceedBtnLabel: "Ok",
            dType: "ERROR"
        } as IAlertDialogData);
      } else {
        this.as.fireEvent(IrbEditorsEvents.SAVE_START, { "slot": this.slot });
        delete this.data.navigationSource;
        this.trackEditEvent(this.data);
        this.data.scheduler = {"isActive":false,"scheduleType":"Adhoc"};
        this.data.schedulerFrequency = 'None';

        if(this.data.smartFilterDto.analysisPortDtoList.length >= this.portfolioThreshold) {
          this.crbservice.saveRebalanceAsync(this.data).subscribe((data: ISaveRebalanceAsync) => {
            this.checkSaveRebalanceAsyncStatus(data.rprasId);
          }, () => {
            this.as.fireEvent(IrbEditorsEvents.SAVE_ERROR, { "slot": this.slot });
            this.setGlobalError();
          });
        } else {
          this.crbservice.saveRebalance(this.data).subscribe((data: ISaveRebalanceResponse) => {
            this.completeSaveRebalance(data);
          }, () => {
            this.as.fireEvent(IrbEditorsEvents.SAVE_ERROR, { "slot": this.slot });
            if (!this.isUnitTest)
              this.setGlobalError();
          });
        }
      }
    });
  }

  completeSaveRebalance(response: ISaveRebalanceResponse) {
          if (response.responseStatus === "SUCCESS") {            
            if (response.responseUtilityMap != null) {
              let analysisId = String(response.responseUtilityMap.analysisId);
              let rebalanceResultId = String(response.responseUtilityMap.rebalanceResultId);
              let rebalanceName = response.responseUtilityMap.rebalanceName;

              let submitTiQueueReq: any = {Package: analysisId, RebalanceResult: rebalanceResultId};

              let saveSuccessEventData: {};
              let hasPendFunc: boolean = this.hasPendingFunction;

              if (!hasPendFunc) {
                saveSuccessEventData = { "hasPendingFunction": hasPendFunc, "slot": this.slot };
              } else {
                saveSuccessEventData = { "hasPendingFunction": hasPendFunc, "data": rebalanceName+" Rebalance Submitted", "slot": this.slot };
              }

              this.submitPackageToQueue(submitTiQueueReq, rebalanceName, rebalanceResultId, hasPendFunc, saveSuccessEventData);
            }
          } else {
            this.as.fireEvent(IrbEditorsEvents.SAVE_ERROR, { "slot": this.slot });
            if (!this.isUnitTest)
              this.setGlobalError();
          }
  }

  submitPackageToQueue(submitTiQueueReq: any, rebalanceName: string, rebalanceResultId: any, hasPendFunc: boolean, saveSuccessEventData: any) {
    this.rebalanceService.submitPortfoliosToQueue(submitTiQueueReq).subscribe(() => {
      if (!hasPendFunc) {
        this.alertUserOnSubmissionOrSave(rebalanceName, rebalanceResultId, saveSuccessEventData);
      } else {
        setTimeout(() => { this.as.fireEvent(IrbEditorsEvents.SAVE_SUCCESS, saveSuccessEventData); });
      }
    });
  }

  alertUserOnSubmissionOrSave(rebalanceName: string, rebalanceResultId: any, saveSuccessEventData: any) {
    this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
      dTitle: "Rebalance Submitted",
      msg: rebalanceName,
      altMsg: "Go to rebalance results summary to check the status of this submission.",
      dProceedBtnLabel: "Go to Rebalance Result Summary",
      dType: "WARN",
      onProceed: (() => {
          this.navigateToResultSummary(rebalanceResultId);
          this.closeWithoutSave();
      }).bind(this),
      onCancel: (() => {
          this.closeWithoutSave();
      }).bind(this)
    } as IAlertDialogData);

    setTimeout(() => { this.as.fireEvent(IrbEditorsEvents.SAVE_SUCCESS, saveSuccessEventData); });
  }

  navigateToResultSummary(rebalanceResultId: any) {
    this.router.navigateByUrl("/rebalancing/rebalance-results", { skipLocationChange: true }).
    then(() => this.router.navigate(["/rebalancing/result-summary/", rebalanceResultId]));
  }

  navigateToScheduledRebalances() {
    this.router.navigate(['/rebalancing/scheduled-rebalances']);
  }

  @HostListener("window:resize", ["$event"])
  onResize() {
      if (this.body) {
          const rect = this.body.nativeElement.getBoundingClientRect();
          let h = (window.innerHeight - rect.top - 10);

          h = (h < 200) ? 200 : h;
          this.bodyHeight = h + "px";
      }
  }

  getPortfolioCount() {
    if(this.data && this.data.isUIAllPort && this.data.isUIAllPort == true) {
      return "All portfolios included";
    }
    if(this.data?.smartFilterDto?.analysisPortDtoList !==null
        && this.data?.smartFilterDto?.analysisPortDtoList !==undefined
        && this.data?.smartFilterDto?.analysisPortDtoList?.length) {
      if(this.data?.smartFilterDto?.analysisPortDtoList?.length > 1) {
        return this.data?.smartFilterDto?.analysisPortDtoList?.length + " portfolios included";
      } else if (this.data?.smartFilterDto?.analysisPortDtoList?.length === 1) {
        return this.data?.smartFilterDto?.analysisPortDtoList?.length + " portfolio included";
      } else {
        return 0 + " portfolios included";
      }
    } else {
      return 0 + " portfolios included";
    }
  }
}
